module.exports = __webpack_public_path__ + "static/media/1014367.ef9ec616.jpg";